import FormInputAsycnPaginate from "../../shared/FormInputAsycnPaginate";
import FormInputText from "../../shared/FormInputText";
import { useQuery } from '@tanstack/react-query';
import FormSelect from "../../shared/FormSelect";
import { fetchTemplateRiderComp, getProducts } from "../../../utils/apiUtils";
import { loadAccountHccIdentificationNumber, loadTemplates } from "../../../utils/optionLoaderUtils";
import { ACTIONS } from "../../../utils/constants";
import FormDate from "../../shared/FormDate";

const step = 1;
const StepOne = ({ activeStep, control, errors, register, setValue, getValues }) => {
    if (activeStep !== step) return;
    const action = getValues('action')

    const { data: products } = useQuery({
        queryKey: ['getProducts'],
        queryFn: getProducts,
        select: (data) => data.rows.map(row => ({ value: row.productName, label: row.productName, additional: row }))
    })

    return (
        <>
            <input
                style={{
                    // display: 'none'
                    visibility: "hidden",
                    height: '0px'
                }}
                disabled
                {...register("draftId", {
                    required: "draftId is required",
                })} // custom message
            />
            {action === ACTIONS.AMEND &&
                <div style={{ paddingBottom: '2rem' }}>
                    <FormDate label={'As of date'} name={'asOfDate'} control={control} errors={errors} />
                </div>}

            <FormInputAsycnPaginate
                label={"Account"}
                name={"account"}
                control={control}
                loadOptions={loadAccountHccIdentificationNumber}
                errors={errors}
                placeholder="Select an account"
            />
            <br />
            <FormSelect
                label={'Product'}
                name={'product'}
                control={control}
                options={products}
                errors={errors}
                placeholder="Select a product"
            />

            <p style={{ paddingBottom: '1rem', fontWeight: 700 }}> ‼️ Warning updating template will clear all chosen riders. </p>

            <FormInputAsycnPaginate
                label={"Template"}
                name={"template"}
                control={control}
                loadOptions={loadTemplates}
                errors={errors}
                placeholder="Select a template"
                onSelectedHandler={async (template) => {
                    [
                        'coverageTierSetRider',
                        'dependentAgeOutPolicyRider',

                        'bankAccount',
                        'valueList',
                        'cob.overwrite',
                        'repricer',
                        'repricerRuleRider',
                        'networkDefinitionRider',

                        'nonParticipatingPricingNoControl',
                        'nonParticipatingPricingTrueOutOfNetwork',

                        'vendors',

                        'accumulatorFromMapping',
                        'accumulator',

                        'rules',

                        'costShareBenefitDetails.preventiveCare.overwrite',
                        'costShareBenefitDetails.physicianServices',
                        'costShareBenefitDetails.hospitalServices',
                        'costShareBenefitDetails.specialServices',

                        'exclusions.clientSpecific',
                        'limits.clientSpecific',


                        'preCertRules',
                        'extraRiders'


                    ].map(name => setValue(name, null))
                    // const account = getValues('account')
                    // // const bankAccountRiderRes = await fetch(`${process.env.VITE_BACKEND_URL}/template/search?searchText=${encodeURIComponent(account.label)}&category=Bank+Account&`)
                    // const bankAccountRiderRes = await fetchTemplateRiderComp({ category: 'Bank Account', searchText: account.label, })
                    // const accountRider = bankAccountRiderRes.hits?.hits?.[0]?._source.metadata

                    // if (accountRider) {
                    //     setValue('bankAccount', {
                    //         value: accountRider?.benefitPlanRiderHccId,
                    //         label: accountRider?.benefitPlanRiderName,
                    //         additional: accountRider
                    //     })
                    // } else {
                    //     setValue('bankAccount', null)
                    // }

                    // const determinatonOrderRes = await fetchTemplateRiderComp({ category: 'Benefit Determination Order', bnftPlanTemplateHstFctKey: template?.additional?.bnftPlanTemplateHstFctKey, })
                    // const determinatonOrder = determinatonOrderRes.hits?.hits?.[0]?._source.metadata
                    // if (determinatonOrder) {
                    //     setValue('rules.benefitDeterminatonOrder', {
                    //         value: determinatonOrder?.benefitPlanRiderHccId,
                    //         label: determinatonOrder?.benefitPlanRiderName,
                    //         additional: determinatonOrder
                    //     })
                    // } else {
                    //     setValue('rules.benefitDeterminatonOrder', null)
                    // }


                    // const preventiveCareRes = await fetchTemplateRiderComp({ category: 'Benefits - Preventive', bnftPlanTemplateHstFctKey: template?.additional?.bnftPlanTemplateHstFctKey, })
                    // const preventiveCare = preventiveCareRes.hits?.hits?.[0]?._source.metadata
                    // if (preventiveCare) {
                    //     setValue('costShareBenefitDetails.preventiveCare.type', {
                    //         value: preventiveCare?.benefitPlanCompName,
                    //         label: preventiveCare?.benefitPlanCompName,
                    //         additional: preventiveCare
                    //     })
                    // } else {
                    //     setValue('costShareBenefitDetails.preventiveCare.type', null)
                    // }

                }}
            />

            <br />
            <FormInputText label={'Plan name'} register={register} name={'benefitPlanName'} errors={errors} placeholder="Benefit plan name" />
            <FormInputText label={'Plan HCC ID'} register={register} name={'benefitPlanHccId'} errors={errors} placeholder="Benefit plan HCC ID" />

            <div className="form-input">
                <label>Description</label>
                <textarea {...register("benefitPlanDesc")} style={{ height: "48px" }} />
                {errors["benefitPlanDesc"] &&
                    <p style={{ color: "var(--red)", paddingTop: ".4rem" }}>{errors["benefitPlanDesc"]?.message}</p>}
            </div>
            {/* 
            <br />
            <FormCheckbox label={'Is High Deductible Plan?'} name={'isHighDeductiblePlan'} register={register} /> */}
        </>
    );
};

export default StepOne;
